import { Box } from "@mui/material";
import * as React from "react";
import { Card } from "../../shared/cards/Card.styled";
import { BodyText } from "../../shared/text/BodyText.styled";
import { ediphiPalette } from "../../styles/colors";

interface HeroListItem {
  icon: string;
  primaryText: string;
}

const ITEMS: HeroListItem[] = [
  { icon: "assets/icons/instantly_export.svg", primaryText: "Link to your Ediphi project" },
  { icon: "assets/icons/customize_reports.svg", primaryText: "Customize your reports for clients" },
  { icon: "assets/icons/refresh_data.svg", primaryText: "Refresh your data at any time" },
];

const ICON_SIZE = 20;

const HeroList: React.FC = () => (
  <Box sx={{ display: "flex", flexDirection: "column", gap: 1, width: "100%" }}>
    {ITEMS.map((item) => (
      <Card key={item.primaryText} sx={{ alignItems: "center", gap: 1.5, py: 1.5 }}>
        <img src={item.icon} alt="" width={ICON_SIZE} height={ICON_SIZE} />
        <BodyText sx={{ color: ediphiPalette.mainTextColor, fontWeight: 500 }}>{item.primaryText}</BodyText>
      </Card>
    ))}
  </Box>
);

export default HeroList;
